import { isSiDaMember } from '@util'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import CateForm from '../../../Common/CateForm'
import style from './index.module.less'
import MenuItem from './menuItem'

@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      formValue: {}
    }
  }
  submitCasseCate = values => {
    this.setState({
      visible: false
    })
    this.props.store.submitCasseCate(values)
  }
  editCaseCate = (e, formValue) => {
    e.stopPropagation()
    this.setState({
      visible: true,
      formValue
    })
  }
  render() {
    const { menuList } = this.props.store
    return (
      <Fragment>
        <ul className={style.menu}>
          {menuList.map((item, index) => {
            return (
              <MenuItem
                store={this.props.store}
                item={item}
                key={item.id}
                index={index}
                editCaseCate={this.editCaseCate}
              />
            )
          })}
          {!isSiDaMember() && (
            <li style={{ marginTop: '8px', marginLeft: '20px' }}>
              <Button
                onClick={() => this.setState({ visible: true, formValue: {} })}
              >
                新建分类
              </Button>
            </li>
          )}
        </ul>
        <CateForm
          visible={this.state.visible}
          onClose={() => this.setState({ visible: false })}
          onOk={this.submitCasseCate}
          formValue={this.state.formValue}
        />
      </Fragment>
    )
  }
}

export default Index
